export const ID_FILTER_SEARCH = "search";
export const ID_FILTER_REPORT_CREATIONDATEFROM ="report-date-from";
export const ID_FILTER_REPORT_CREATIONDATETO ="report-date-to";
export const ID_FILTER_CODE = "code";
export const ID_FILTER_NAME ='name';
export const ID_FILTER_DMS ='dms';
export const ID_FILTER_STATUSES = "statuses";
export const ID_FILTER_CONTRACTOR = "contractor";
export const ID_FILTER_PRINTOUT_CREATIONDATEFROM ="printout-date-from";
export const ID_FILTER_PRINTOUT_CREATIONDATETO ="printout-date-to";
export const ID_FILTER_PRINTOUT_SENTDATEFROM ="sent-date-from";
export const ID_FILTER_PRINTOUT_SENTDATETO ="sent-date-to";
export const ID_FILTER_LEGAL_ENTITIES = "legal-entities";
export const ID_FILTER_DEALERS = "dealers";


export const royaltiesReportDefaultValues = { creationDateFrom: null, creationDateTo: null };